import { render } from "./ResetPassword.vue?vue&type=template&id=f234e42c"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"
script.render = render

export default script